var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { BASE_NUGGET_IMAGE_MAX_HEIGHT } from './BaseNugget';
export var NuggetInstitution = function (_a) {
    var variant = _a.variant;
    var _b = useState(false), isPreviewImageLoaded = _b[0], setIsPreviewImageLoaded = _b[1];
    if (variant.type === 'LARGE') {
        return variant.previewImage ? (_jsxs(Box, { sx: __assign(__assign({}, imageContainerStyle), { display: isPreviewImageLoaded ? 'flex' : 'none' }), onClick: function () { return window.open(variant.institutionUrl, '_blank'); }, onError: function () { return setIsPreviewImageLoaded(false); }, onLoad: function () { return setIsPreviewImageLoaded(true); }, children: [_jsx("img", { src: variant.previewImage, alt: variant.institutionUrl, style: imageStyle }), _jsx(Box, { component: "a", href: variant.institutionUrl, target: "_blank", rel: "noopener noreferrer", sx: institutionUrlStyle, children: variant.institutionUrl })] })) : (_jsx(Box, { sx: institutionUrlStyle, children: _jsx(Typography, { variant: "body1", component: "a", href: variant.institutionUrl, target: "_blank", rel: "noopener noreferrer", children: variant.institutionUrl }) }));
    }
    return (_jsx(_Fragment, { children: variant.previewImage && (_jsx(Box, { component: "img", src: variant.previewImage, alt: "Institution", sx: __assign(__assign({}, smallImageContainerStyle), { display: isPreviewImageLoaded ? 'block' : 'none' }), onError: function () { return setIsPreviewImageLoaded(false); }, onLoad: function () { return setIsPreviewImageLoaded(true); } })) }));
};
var imageContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflow: 'hidden',
    width: '100%',
    height: 'auto',
    mt: 6,
    cursor: 'pointer',
};
var smallImageContainerStyle = __assign(__assign({}, imageContainerStyle), { maxHeight: BASE_NUGGET_IMAGE_MAX_HEIGHT, minHeight: 'unset', width: '100%', backgroundColor: 'transparent', borderRadius: '16px', objectFit: 'cover', aspectRatio: '16/9' });
var imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '16px',
    aspectRatio: '16/9',
    maxHeight: BASE_NUGGET_IMAGE_MAX_HEIGHT,
};
var institutionUrlStyle = {
    cursor: 'pointer',
    mt: 1,
};
